import { useState } from "react";
import ContactModal from "./ContactModal";

export default function TechnologyCTA() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className="py-24 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-12">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
              <i className="ri-mail-line text-[#2D7A3E] text-lg mr-2"></i>
              <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">お問い合わせ</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
              技術について<br className="md:hidden" />詳しく知りたい方へ
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              循環型陸上養殖システムの詳細や導入についてのご相談は、<br className="hidden md:block" />
              お気軽にお問い合わせください。
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9]">
              <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-[#1A2332] mb-2">技術資料</h3>
              <p className="text-sm text-gray-600">詳細な技術資料をご提供</p>
            </div>

            <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9]">
              <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-[#1A2332] mb-2">施設見学</h3>
              <p className="text-sm text-gray-600">実際の施設をご案内</p>
            </div>

            <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9]">
              <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-discuss-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-[#1A2332] mb-2">個別相談</h3>
              <p className="text-sm text-gray-600">専門スタッフが対応</p>
            </div>
          </div>

          <button
            onClick={() => setIsModalOpen(true)}
            className="px-10 py-4 bg-[#2D7A3E] text-white font-semibold rounded-lg hover:bg-[#245A30] transition-colors duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
          </button>
        </div>
      </section>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}